<style scoped lang="scss">
/deep/ .el-badge__content {
  height: auto;
}

/deep/ .el-popover {
  position: absolute;
  background: #fff;
  min-width: 150px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  //padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  //-webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  //box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  word-break: break-all;
}

.header {
  width: 100%;
  background: white;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  box-shadow: 5px 0px 5px 0px rgba(0, 0, 0, 0.1);

  .left {
  }

  .right {
    display: flex;
    align-items: center;
  }
}

.ai-items {
  display: flex;
  flex-direction: column;

  .ai-item:hover {
    background-color: #f5f7fa;
  }

  .ai-item {
    padding: 5px 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #6ec543;
  }
}
</style>
<style lang="less"></style>
<template>
  <div class="header">
    <div class="left"></div>
    <div class="right">
      <div style="margin-right: 36px;display: flex;align-items: center;" v-if="aiApplications.length > 0">
        <el-popover placement="bottom-start" width="300" trigger="click">
          <div class="ai-items">
            <div class="ai-item" v-for="(item, index) in aiApplications" :key="index" @click="openTab(item.route)">{{ item.name }}</div>
          </div>
          <img slot="reference" style="width: 100px; height: 30px;cursor: pointer;" src="../../assets/img/header/yiai.png" />
        </el-popover>
      </div>
      <div style="margin-right: 36px;">
        <el-dropdown style="color: #606266;cursor: pointer;" trigger="click" @command="changeLocale">
          <span class="el-dropdown-link">
            <i class="yicon yicon-language" style="margin-right: 4px;"></i>
            {{
              {
                zh_CN: $t('zhongwen'),
                en_US: $t('yingwen'),
                de_DE: $t('deyu'),
                ru_RU: $t('eyu'),
                vi_VN: $t('yuenanyu')
              }[lang]
            }}
            <i class="yicon yicon-arrow_down" style="margin-left: 4px;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">{{ $t('zhongwen') }}</el-dropdown-item>
            <el-dropdown-item command="1">{{ $t('yingwen') }}</el-dropdown-item>
            <el-dropdown-item command="2">{{ $t('deyu') }}</el-dropdown-item>
            <el-dropdown-item command="3">{{ $t('eyu') }}</el-dropdown-item>
            <el-dropdown-item command="4">{{ $t('yuenanyu') }}</el-dropdown-item>
            <!-- <el-dropdown-item command="3">{{ $t('alaboyu') }}</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--消息管理-->
      <div style="margin-right: 36px;" class="_popover">
        <el-popover width="550" trigger="click">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane :label="$t('xitongxiaoxi')" name="system">
              <div style="display:flex;flex-direction: row;margin: 20px 20px 0px 20px" v-for="(item, index) in messageList" :key="index">
                <!--标题-->
                <div style="display: flex;justify-content: flex-start">
                  <div style="display: flex;flex-direction: column">
                    <div style="display: flex;flex-wrap: nowrap;flex-direction: row;align-items: center">
                      <span v-if="unreadSizeTtotal !== 0 && item.status == '0'" style="background-color: #F56C6C;display: inline-block;width: 10px;height: 10px;border-radius: 50%;"></span>
                      <span v-if="unreadSizeTtotal == 0 || item.status == '1'" style="background-color: #ffffff;display: inline-block;width: 10px;height: 10px;border-radius: 50%;"></span>
                      <span style="margin-left: 8px;color: #303133;font-size: 14px;font-family:Microsoft YaHei UI">{{ item.sender.nickname | ellipsis }}</span>
                    </div>
                    <span style="margin: 8px 0px 15px 17px"> {{ item.title | ellipsis }}</span>
                  </div>
                </div>
                <!--发送时间-->
                <div style="display: flex;flex: 1; justify-content: flex-end;margin-top: 28px">{{ dateItemFormat(item.createTime) }}</div>
              </div>
              <!--标记已读信息 -->
              <div>
                <div style="width: 100%;border: 1px solid #E4E7ED;margin-top: 20px"></div>
                <div style="display: flex;flex-wrap: nowrap;justify-content: space-around;align-items: center;">
                  <el-button :loading="loading" :disabled="readDisabled" @click="allRead()" style="font-weight: 400;font-size: 14px;" type="text">{{ $t('quanbubiaoweiyidu') }} </el-button>
                  <div style="width: 1px;height: 50px;border: 1px solid #E4E7ED;"></div>
                  <el-button style="font-weight: 400;font-size: 14px;" @click="$router.push('/web/system/message_management')" type="text">{{ $t('chakangengduoxiaoxi') }} </el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('shenpixiaoxi')" name="check">
              <div style="display:flex;flex-direction: row;margin: 20px 20px 0px 20px" v-for="(item, index) in checkMessageList" :key="index">
                <!--标题-->
                <div style="display: flex;justify-content: flex-start">
                  <div style="display: flex;flex-direction: column">
                    <div style="display: flex;flex-wrap: nowrap;flex-direction: row;align-items: center">
                      <span style="background-color: #F56C6C;display: inline-block;width: 10px;height: 10px;border-radius: 50%;"></span>
                      <span style="background-color: #ffffff;display: inline-block;width: 10px;height: 10px;border-radius: 50%;"></span>
                      <span style="margin-left: 8px;color: #303133;font-size: 14px;font-family:Microsoft YaHei UI">{{ item.flow.promoterName | ellipsis }}</span>
                    </div>
                    <span style="margin: 8px 0px 15px 17px"> {{ item.flow.title | ellipsis }}</span>
                  </div>
                </div>
                <!--发送时间-->
                <div style="display: flex;flex: 1; justify-content: flex-end;margin-top: 28px">{{ dateItemFormat(item.createTime) }}</div>
              </div>
              <div>
                <div style="width: 100%;border: 1px solid #E4E7ED;margin-top: 20px"></div>
                <div style="display: flex;flex-wrap: nowrap;justify-content: space-around;align-items: center;">
                  <el-button style="font-weight: 400;font-size: 14px;" @click="$router.push('/web/system/process?ativeName=checkPending')" type="text">{{ $t('qianwangchuli') }} </el-button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div
            slot="reference"
            @click="
              getRecentList();
              getUnreadSize();
              getCheckMessageList();
            "
          >
            <el-badge v-if="unreadSizeTtotal !== 0" class="item" :value="unreadSizeTtotal" :max="100" style="color: #606266;"><i class="yicon yicon-message_alert" style="margin-right: 4px;"></i> </el-badge>
            <el-button slot="reference" style="margin-left: 10px;font-size: 14px;color: #606266;" type="text">
              {{ $t('xiaoxi') }}
            </el-button>
            <i slot="reference" class="yicon yicon-arrow_down" style="margin-left: 4px;"></i>
          </div>
        </el-popover>
      </div>
      <div style="margin-right: 36px;">
        <el-button style="color: #606266;" type="text" @click.native="toggleFullScreen()"> <i v-show="!isFullscreen" class="yicon yicon-fullscreen" style="margin-right: 4px;"></i><i v-show="isFullscreen" class="yicon yicon-normal_screen" style="margin-right: 4px;"></i>{{ $t('quanping') }} </el-button>
      </div>
      <div style="margin-right: 36px;" v-if="store.state.customer.type != null">
        <el-button style="color: #606266;" type="text" @click="toZhiyin()"> <i class="yicon yicon-help" style="margin-right: 4px;"></i>{{ $t('caozuozhiyin') }} </el-button>
      </div>
      <!--  导出任务    -->
      <div style="margin-right: 36px;">
        <el-popover v-model="isShowExportDialog" placement="bottom" width="600" trigger="click">
          <!--          <div style="font-weight: 400;font-size: 18px;margin-left: 20px;"> {{$t('daochurenwu')}}</div>-->
          <div style="margin-top: -10px;position: relative;">
            <web_system_export_list :fixShowColumns="exportColumns" :isShowTop2="false" :isShowCondition="false" :fixContainerHeight="500" ref="export"></web_system_export_list>
            <el-button @click="$router.push('/web/system/export')" style="color: #419FFF;font-weight: 400;font-size: 14px;position: absolute;bottom: 10px;right: 20px;" type="text"
              >{{ $t('chakansuoyoudaochurenwu') }}
              <i class="yicon yicon-dblarrow_right el-icon--right"></i>
            </el-button>
          </div>

          <el-button
            @click="
              $refs.export.yt.conditions['orderBy'] = 'createTime desc';
              $refs.export.yt.isShowPagination = false;
              $refs.export.yt.pageSize = 5;
              $refs.export.yt.get(1);
            "
            slot="reference"
            style="color: #606266;"
            type="text"
            ><i class="yicon yicon-file_download" style="margin-right: 4px;"></i>{{ $t('daochurenwu') }}
          </el-button>
        </el-popover>
      </div>
      <!-- <div style="background: #606266;margin-right: 36px;width: 1px;height: 24px;"></div> -->
      <div style="margin-right: 36px;">
        <el-dropdown @command="handleCommand" trigger="click">
          <div style="display: flex;cursor: pointer;align-items: center;">
            <!-- <div>
              <el-image :fit="'cover'"
                style="width: 24px;height: 24px;background: red;border-radius: 50%;margin-right: 8px;"
                :key="'a'" :src="'a'" lazy></el-image>
            </div> -->
            <div>{{ store.state.user.nickname }}</div>
          </div>
          <div v-if="store.state.customer">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="2" icon="el-icon-out">{{ $t('zhanghaoxinxi') }}</el-dropdown-item>
              <el-dropdown-item command="1" icon="el-icon-out">{{ $t('xiugaimima') }}</el-dropdown-item>
              <el-dropdown-item command="0" icon="el-icon-out">{{ $t('tuichudenglu') }}</el-dropdown-item>
            </el-dropdown-menu>
          </div>
          <div v-else>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" icon="el-icon-out">{{ $t('xiugaimima') }}</el-dropdown-item>
              <el-dropdown-item command="0" icon="el-icon-out">{{ $t('tuichudenglu') }}</el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
    </div>
    <el-dialog @close="closeDialog(pwdFrom)" :show-close="true" :title="$t('xiugaimima')" :visible.sync="isShowPasswordDialog" :close-on-click-modal="true" width="380px">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" size="mini">
        <el-form-item :label="$t('yuanmima')" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xinmima')" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('querenmima')" prop="confirmPassword">
          <el-input type="password" v-model="ruleForm.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          @click="
            isShowPasswordDialog = false;
            resetForm('ruleForm');
          "
          >{{ $t('quxiao') }}
        </el-button>
        <el-button size="mini" @click="resetForm('ruleForm')">{{ $t('chongzhi') }}</el-button>
        <el-button size="mini" @click="modifyPwd(ruleForm)" type="primary">{{ $t('baocun') }} </el-button>
      </span>
    </el-dialog>
    <!-- 账号信息 -->
    <el-dialog v-if="store.state.customer" :show-close="true" :title="$t('zhanghaoxinxi')" :visible.sync="isShowAccountDialog" :close-on-click-modal="true" width="600px" append-to-body="append-to-body">
      <el-form status-icon label-width="100px" size="mini" style="margin-top: 20px;margin-left: 70px;">
        <el-form-item class="noborder" :label="$t('yonghuzhanghao')" prop="oldPassword">
          <el-input disabled v-model="store.state.user.username"></el-input>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('yonghumingcheng')" prop="oldPassword">
          <el-input disabled v-model="store.state.user.nickname"></el-input>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('kehumingcheng')" prop="confirmPassword">
          <el-input disabled v-model="store.state.customer.name"></el-input>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('kehujiancheng')" prop="confirmPassword">
          <el-input disabled v-model="store.state.customer.shortName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('kehuchuangjianshijian')">
          <span style="margin-left: 12px;">{{ store.state.customer.createTime == null || '' ? '-' : dateItemFormat(store.state.customer.createTime) }}</span>
        </el-form-item>
        <el-form-item :disabled="disabled" :label="$t('kehushixiaoshijian')">
          <span style="margin-left: 12px;">{{ store.state.customer.endTime == null || '' ? '-' : dateItemFormat(store.state.customer.endTime) }}</span>
        </el-form-item>
        <el-form-item style="margin-top: 60px;"></el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'yi_header',
  data() {
    // 校验原密码
    var validateOldPass = (rule, value, callback) => {
      console.log('old:', value);
      if (value == '') {
        callback(new Error(this.$t('qingshuruyuanmima')));
      } else {
        callback();
      }
    };
    // 校验新密码
    var validateNewPass = (rule, value, callback) => {
      console.log('newPass:', value);
      if (value === '') {
        callback(new Error(this.$t('qingshuruxinmima')));
      } else {
        if (this.rules.confirmPassword !== '') {
          this.$refs.ruleForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    // 确认密码校验
    var validateConfirmPass = (rule, value, callback) => {
      console.log('confirm:', value);
      if (value === '') {
        callback(new Error(this.$t('qingzaicishuruxinmima')));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error(this.$t('liangcishurumimabuyizhi')));
      } else {
        callback();
      }
    };
    return {
      aiApplications: [],
      activeName: 'system',
      messageList: [],
      checkMessageList: [],
      unreadSizeTtotal: '', //未读消息总数
      readAll: '', //全部已读
      disabled: false,
      readDisabled: false,
      loading: false,
      timmer: null,
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          {
            validator: validateOldPass,
            trigger: 'blur'
          },
          {
            validator: validateOldPass,
            trigger: 'change'
          }
        ],
        newPassword: [
          {
            validator: validateNewPass,
            trigger: 'blur'
          },
          {
            validator: validateNewPass,
            trigger: 'change'
          }
        ],
        confirmPassword: [
          {
            validator: validateConfirmPass,
            trigger: 'blur'
          },
          {
            validator: validateConfirmPass,
            trigger: 'change'
          }
        ]
      },
      isShowPasswordDialog: false,
      isShowAccountDialog: false,
      lang: localStorage.getItem('lang'),
      isFullscreen: false,
      //导出任务的columns
      isShowExportDialog: false,
      exportColumns: [
        {
          label: 'renwumingcheng',
          prop: 'workName',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm'
        },
        {
          label: 'renwuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            '0': {
              color: '#419FFF',
              text: this.$t('jinxingzhong')
            },
            '-1': {
              color: '#F56C6C',
              text: this.$t('shibai')
            },
            '1': {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ]
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 25) {
        return value.slice(0, 25) + '...';
      }
      return value;
    }
  },
  watch: {
    unreadSizeTtotal: {
      handler(n) {
        if (n == 0) {
          this.readDisabled = true;
        }
      },
      immediate: false,
      deep: true
    }
  },
  mounted() {
    console.log('this.i18n.locale', this.i18n.locale);
    this.utils.event_hub.$on('READ_REFRESH', () => {
      this.getUnreadSize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    // clearTimeout(this.timer)
  },
  created() {
    this.getAiApplications();
    this.utils.event_hub.$on('READ_REFRESH', () => {
      this.getUnreadSize();
    });
    this.getUnreadSize();
    this.timmer = setInterval(() => {
      this.getUnreadSize();
      this.utils.event_hub.$emit('READ_REFRESHS', this.unreadSizeTtotal);
    }, 30000);
    this.utils.event_hub.$on('SHOW_HEADER_EXPORT_DIALOG', () => {
      this.$refs.export.yt.conditions['orderBy'] = 'createTime desc';
      this.$refs.export.yt.isShowPagination = false;
      this.$refs.export.yt.pageSize = 5;
      this.$refs.export.yt.get(1);
      this.isShowExportDialog = true;
    });
    window.addEventListener(
      'keydown',
      () => {
        if (event.keyCode === 122) {
          event.returnValue = false;
          this.toggleFullScreen();
          //this.fullScreen() //触发全屏的按钮
        }
      },
      true
    ); // 监听按键事件
  },
  methods: {
    openTab(route) {
      this.$router.push(route).catch(err => {
        // 处理重复路由之外的问题
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    getAiApplications() {
      const aiApplications = [];
      const menus = this.$store.state.menus || [];
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu.code === 'web_ai') {
          const children = menu.children || [];
          for (let j = 0; j < children.length; j++) {
            const child = children[j];
            // 只添加有权限的菜单
            const obj = {
              name: this.$t(child.code),
              route: child.route
            };
            aiApplications.push(obj);
          }
        }
      }
      this.aiApplications = aiApplications;
    },
    allRead() {
      this.loading = true;
      this.getReadAll();
      this.getUnreadSize();
      this.getRecentList();
      this.getCheckMessageList();
      this.utils.event_hub.$emit('READ_REFRESHS', this.unreadSizeTtotal);
      this.loading = false;
    },
    //获取最新的四条消息
    async getRecentList() {
      let response = await this.http.get('/web/msg/im/recent', {
        params: {
          pageNum: 1,
          pageSize: 4
        }
      });
      this.messageList = response.data;
    },
    //获取最新的 4 条待审核消息
    async getCheckMessageList() {
      let response = await this.http.get('/web/process/flowNode/page?nodeStatus=1', {
        params: {
          pageNum: 1,
          pageSize: 4
        }
      });
      this.checkMessageList = response.data.rows;
      console.log(this.checkMessageList);
    },
    //未读消息总数量
    async getUnreadSize() {
      let response = await this.http.get('/web/msg/im/unreadSize', {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      });
      this.unreadSizeTtotal = response.data;
      //若未读消息总数量为0，则全部标为已读按钮置灰
      if (this.unreadSizeTtotal == 0) {
        this.readDisabled = true;
      } else {
        this.readDisabled = false;
      }
    },
    //全部设置为已读
    getReadAll() {
      return this.http
        .post('/web/msg/im/readAll')
        .then(response => {
          this.readAll = response.data;
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },

    dateItemFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      const hash = {
        Y: year,
        m: month,
        d: day
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    fullScreen(el) {
      this.isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (!this.isFullscreen) {
        //进入全屏,多重短路表达式
        (el.requestFullscreen && el.requestFullscreen()) || (el.mozRequestFullScreen && el.mozRequestFullScreen()) || (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) || (el.msRequestFullscreen && el.msRequestFullscreen());
      } else {
        //退出全屏,三目运算符
        document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : '';
      }
      setTimeout(() => {
        this.utils.event_hub.$emit('RESIZE_INDEX');
      }, 500);
    },
    toggleFullScreen(e) {
      var el = document.documentElement;
      this.fullScreen(el);
    },
    handleCommand(command) {
      if (command == 0) {
        // 先调服务端退出，再清本地 token（请求拦截器依赖 localStorage.token）
        this.http
          .post('/web/auth/logout')
          .catch(() => {})
          .finally(() => {
            window.localStorage.removeItem('token');
            this.utils.event_hub.$emit('NEED_LOGIN', null);
          });
      }
      if (command == 1) {
        this.showPasswordDialog(null, null, 'w2');
      }
      if (command == 2) {
        this.ShowAccountDialog(null, null, 'w2');
      }
    },
    changeLocale(e) {
      let locale = this.i18n.locale;
      this.i18n.locale = ['zh_CN', 'en_US', 'de_DE', 'ru_RU', 'vi_VN'][e];
      localStorage.setItem('lang', ['zh_CN', 'en_US', 'de_DE', 'ru_RU', 'vi_VN'][e]);
      window.location.href = '/';
    },
    showPasswordDialog() {
      this.isShowPasswordDialog = true;
    },
    ShowAccountDialog() {
      this.isShowAccountDialog = true;
    },
    modifyPwd(o) {
      this.http
        .post('/web/customer/auth/user/modifyPwd', {
          oldPassword: o.oldPassword,
          newPassword: o.newPassword,
          confirmPassword: o.confirmPassword
        })
        .then(res => {
          this.utils.successMessage(res.msg);
          this.isShowPasswordDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    changeInput(e) {
      this.$forceUpdate();
    },
    resetFrom() {
      this.$refs['pwdFrom'].resetFields();
    },
    toZhiyin() {
      if (this.i18n.locale != 'en_US' && (this.store.state.customer.type == 1 || this.store.state.customer.type == 3)) {
        window.open('https://iiot2.yizumi.com/czsc.pdf');
      } else if (this.i18n.locale == 'en_US' && (this.store.state.customer.type == 1 || this.store.state.customer.type == 3)) {
        window.open('https://iiot2.yizumi.com/czsc_english_version.pdf');
      } else if (this.store.state.customer.type == 2) {
        window.open('https://iiot2.yizumi.com/czsc_mes.pdf');
      } else if (this.store.state.customer.type == 4) {
        window.open('https://iiot2.yizumi.com/czsc_wms.pdf');
      } else if (this.store.state.customer.type == 6) {
        window.open('https://iiot2.yizumi.com/czsc_aps.pdf');
      }
    }
  }
};
</script>
